
import { useMemo } from 'react';
import { Attendee } from '@/types/attendee';
import { useTShirtStats } from '@/hooks/admin/useTShirtStats';

/**
 * Hook for calculating and providing admin dashboard statistics
 * with integrated T-shirt statistics
 */
export const useAdminStats = (attendees: Attendee[]) => {
  const totalRegistered = useMemo(() => attendees.length, [attendees]);
  const totalAttended = useMemo(() => attendees.filter(a => a.attended).length, [attendees]);
  
  // Only count contributions from attendees who have paid
  const totalContribution = useMemo(() => 
    attendees
      .filter(a => a.paid === true)
      .reduce((sum, a) => sum + (a.contribution || 0), 0), 
    [attendees]
  );
  
  // Get T-shirt statistics using the dedicated hook
  const tShirtStats = useTShirtStats(attendees);
  
  // Calculate some additional useful metrics
  const attendancePercentage = useMemo(() => 
    totalRegistered > 0 ? (totalAttended / totalRegistered) * 100 : 0, 
    [totalAttended, totalRegistered]
  );
  
  return {
    totalRegistered,
    totalAttended,
    totalContribution,
    attendancePercentage,
    tShirtStats
  };
};
